export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceBasicInfo: {
        serviceId: 2,
        serviceName: "〇〇地域サポート",
        communityName: "アイラ地域サポートコミュニティ",
        tenantName: "アイラ株式会社",
        serviceStatus: 1,
        createdAt: 1234567890123,
        updatedAt: 1234567890123
      }
    }
  }
}